import { SetGhModelParametersError } from '@swd_admin/cdc-viewer';
import { useNotificationStore } from 'state/notificationstate/notificationstate';
import { StyleDefinitionError } from '@swd_admin/cdc-viewer';
import { NotEnoughSpaceOptionError } from '@swd_admin/cdc-viewer';
import { useUiState } from 'state/ui-state/ui-state';

export const handleGHModelParametersError = (
  error: SetGhModelParametersError
) => {
  const notification = useNotificationStore.getState();
  notification.setNotification(
    'notifications.viewer.error.ghModelParametersError',
    'error',
    'modal'
  );
};

export const handleStyleDefinitionError = (error: StyleDefinitionError) => {
  console.error(error.data?.map((d) => d.message));
};

export const notEnoughSpaceOptionError = (e: NotEnoughSpaceOptionError) => {
  const notification = useNotificationStore.getState();
  notification.setNotification(
    'notifications.viewer.error.cannotPlaceOptionError',
    'error',
    'small'
  );
};

export const cannotResizeBuildingError = (e: NotEnoughSpaceOptionError) => {
  const { setRemovableInstanceIds } = useUiState.getState();

  setRemovableInstanceIds(e.instanceIds);
};
